import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import { Send } from "lucide-react";

export default function ContactForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
    setErrors((er) => ({ ...er, [name]: undefined }));
  };

  const validate = () => {
    const er = {};
    if (!values.name.trim()) er.name = t("contact.required");
    if (!values.email.trim()) er.email = t("contact.required");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) er.email = t("contact.invalidEmail");
    if (!values.message.trim()) er.message = t("contact.required");
    setErrors(er);
    return Object.keys(er).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    // Push a dataLayer conversion event (respects consent mode)
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "generate_lead", form_location: "contact" });
    }
    // Simulate short delay, then redirect to thank-you (Croatian only)
    setTimeout(() => {
      navigate("/thank_you");
    }, 250);
  };

  return (
    <form onSubmit={onSubmit} noValidate data-testid="contact-form" className="grid gap-4">
      <div>
        <label className="z-label" htmlFor="name">{t("contact.name")}</label>
        <input
          id="name" name="name" type="text"
          className="z-input"
          placeholder={t("contact.namePh")}
          value={values.name}
          onChange={onChange}
          data-testid="cf-name"
          autoComplete="name"
        />
        {errors.name && <p className="text-[12px] text-red-600 mt-1" data-testid="cf-err-name">{errors.name}</p>}
      </div>
      <div>
        <label className="z-label" htmlFor="email">{t("contact.email")}</label>
        <input
          id="email" name="email" type="email"
          className="z-input"
          placeholder={t("contact.emailPh")}
          value={values.email}
          onChange={onChange}
          data-testid="cf-email"
          autoComplete="email"
        />
        {errors.email && <p className="text-[12px] text-red-600 mt-1" data-testid="cf-err-email">{errors.email}</p>}
      </div>
      <div>
        <label className="z-label" htmlFor="message">{t("contact.message")}</label>
        <textarea
          id="message" name="message" rows={5}
          className="z-input resize-none"
          placeholder={t("contact.messagePh")}
          value={values.message}
          onChange={onChange}
          data-testid="cf-message"
        />
        {errors.message && <p className="text-[12px] text-red-600 mt-1" data-testid="cf-err-message">{errors.message}</p>}
      </div>
      <div className="pt-2">
        <button type="submit" disabled={submitting} className="z-btn z-btn-primary" data-testid="cf-submit">
          <Send size={16}/> {t("contact.submit")}
        </button>
      </div>
    </form>
  );
}
